import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import CreateTaskModal from "../components/CreateTaskModal";
import PeriodSelector from "../components/DataInputs/DataPeriodSelector";
import DataSelect from "../components/DataInputs/DataSelect";
import DataTextField from "../components/DataInputs/DataTextField";
import FilterBase from "../components/Filter";
import KanbanDynamic from "../components/KanbanDynamic";
import TaskCard from "../components/TaskCard";
import UpdateTaskModal from "../components/UpdateTaskModal";
import {
	Filter,
	Pagination,
	ResponseContainer,
} from "../interfaces/RequestBase";
import { Status } from "../interfaces/Status";
import { TaskFilter, TaskSearch, TaskTable } from "../interfaces/Task";
import { GetStatuses, GetTasks, UpdateTask } from "../requester/functions";
import getFilter from "../utilities/filter";

const TasksPage = () => {
	const [reset, setReset] = useState<boolean>(false);

	// const [tasks, setTasks] = useState<TaskTable[]>([]);
	const [filter, setFilter] = useState<TaskFilter>({});
	const [search, setSearch] = useState<TaskSearch>({});

	const [status, setStatus] = useState<Status[]>([]);
	const [urgency, setUrgency] = useState<Status[]>([]);

	const [openModal, setOpenModal] = useState<boolean>(false);

	const [selectedTask, setSelectedTask] = useState<TaskTable | null>();
	const [selectedTasks, setSelectedTasks] = useState<number[]>([]);

	const renderCard = (data: TaskTable) => (
		<TaskCard
			key={`task-card-${data.id}`}
			task={data}
			selectTask={setSelectedTask}
			selectedTasks={selectedTasks}
		/>
	);

	const getTasks = (key: Status, page: number, onCB: any) => {
		var req: Filter<TaskFilter, TaskSearch> = getFilter(
			{ page: 0, size: 10 * page } as Pagination,
			{ ...filter, id_status: key.id },
			search
		);

		GetTasks(req, (req) => {
			if (req.status === "ok" && req.data) {
				onCB(key.name, req.data.data);
			} else {
				onCB(key.name, []);
			}
		});
	};

	const onTaskUpdate = (resp: ResponseContainer<null>) => {
		if (resp.status === "error") console.error(resp.message);
		// else getTasks();
	};

	const setKanbanStatus = (item: TaskTable, key: string) => {
		const currentStatus = status.find((s) => s.name === key);

		var statusId: number = 0;
		if (currentStatus) {
			statusId = currentStatus.id;
		}
		UpdateTask(
			{
				id_status: statusId,
				id: selectedTasks.length === 0 ? [item.id] : selectedTasks,
			},
			(resp) => {
				onTaskUpdate(resp);
			}
		);
	};

	useEffect(() => {
		GetStatuses({ filter_by: { type: "task" } }, (resp) => {
			if (resp.status === "ok" && resp.data) {
				setStatus(resp.data);
			}
		});

		GetStatuses({ filter_by: { type: "urgency" } }, (resp) => {
			if (resp.status === "ok" && resp.data) {
				setUrgency(resp.data);
			}
		});
	}, []);

	return (
		<div className="flex flex-col items-end gap-5">
			<div className="w-full flex justify-between">
				<Button
					onClick={() => {
						setOpenModal(true);
					}}
				>
					Создать
				</Button>
				<FilterBase setSearch={setSearch} setFilter={setFilter}>
					<DataTextField
						keyValue={"vacancy_name"}
						value={search}
						setValue={setSearch}
						inputProps={{ label: "Поиск вакансии" }}
					/>
					<DataTextField
						keyValue={"manager_name"}
						value={search}
						setValue={setSearch}
						inputProps={{ label: "Поиск ответственного" }}
					/>
					<PeriodSelector
						value={filter}
						setValue={setFilter}
						keyValue="deadline"
					/>
					<DataTextField
						keyValue={"candidate_name"}
						value={search}
						setValue={setSearch}
						inputProps={{ label: "Поиск кандидата" }}
					/>
					<DataTextField
						keyValue={"watcher_name"}
						value={search}
						setValue={setSearch}
						inputProps={{ label: "Поиск наблюдателя" }}
					/>
					<DataSelect
						keyValue={"id_urgency"}
						list={urgency}
						value={filter}
						setValue={setFilter}
						label="Статус"
					/>
				</FilterBase>
			</div>
			<KanbanDynamic
				columnKeys={status}
				statusKey={"status"}
				renderComponent={renderCard}
				changeEvent={setKanbanStatus}
				columnClassName={"w-1/3"}
				onBottom={(key: Status, page: number, res: any) =>
					getTasks(key, page, res)
				}
				filter={filter}
				search={search}
				reset={reset}
			/>
			<UpdateTaskModal
				open={selectedTask !== null}
				task={selectedTask || undefined}
				onClose={() => {
					setSelectedTask(null);
				}}
				onUpdate={() => {}}
			/>
			<CreateTaskModal
				open={openModal}
				onClose={() => {
					setOpenModal(false);
				}}
				onCreate={() => {
					setReset(!reset);
				}}
			/>
		</div>
	);
};

export default TasksPage;
